import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { CompetitionCalendarQuery } from '../types';

/**
 * typeguard for CompetitionCalendarQuery
 * @param CompetitionCalendarQuery object passed to transformer
 */
export const isValidCompetitionCalendar = (obj: CompetitionCalendarQuery): boolean => Boolean(obj?.data?.getGpCalendarWidget && !isEmptyObject(obj.data.getGpCalendarWidget));
